// import Bridge from "@skland/one-bridge"
export function isSKLand() {
    // return Bridge.getSystemInfo().isApp
    return /skland/i.test(navigator.userAgent);
}
